<template>
  <div>
    <div class="columns is-justify-content-space-between" v-if="!detail">
      <selecteur-action @handleAction="handleAction" class="column is-narrow"
                        :options='actions'
                        :placeholder='$t("general.placeHolder.groupedAction")'
                        :titleButton="'general.button.apply'"
                        :elementsSelectionnes="getAllReglesAchatSelected().length > 0">
      </selecteur-action>
      <div class="column is-narrow">
        <div class="button is-addOrEdit" @click="addRegleAchat()">
          {{ $t('produitSalon.reglesAchat.actions.add') }}
        </div>
      </div>
    </div>
    <div v-else class="columns is-justify-content-end is-align-items-end">
      <div class="column" v-if="produit.regroupementProduit && showMsgRegroupementProduit">
        <msg-info-produit :regroupementProduit="produit.regroupementProduit"/>
      </div>
      <div class="column is-narrow">
        <exportExcelButton
          :perm="permissions.exporter"
          :query="exportExcelQuery"/>
      </div>
    </div>
    <v-client-table v-model="produit.reglesAchat" :columns="columns" :options="options"
                    ref="reglesAchatArray"
                    class="disablePaddingInTd overflow-x-auto min-height-50vw">
      <template v-slot:child_row="props">
        <tranche :data="props.row" :indexRegle="props.index" :detail="detail"
                 @deleteTranche="deleteTranche"
                 @updateTrancheValue="updateValueTranche">
        </tranche>
      </template>
      <div slot="selected" slot-scope="props">
        <b-checkbox :value="props.row.selected" class="mgt-5px"
                    @input="updateValue(props.index, 'selected', $event)">
        </b-checkbox>
      </div>
      <div slot="produitAchatCommissionId" slot-scope="props">
        <b-select
          v-if="!detail"
          v-model="props.row.produitAchatCommissionId"
          @input="updateValue(props.index, 'produitAchatCommissionId', $event)"
          expanded>
          <option :value="null"></option>
          <option
            v-for="item in allProduitAchat"
            :key="item.id"
            :value="item.id">
            {{ item.libelle }}
          </option>
        </b-select>
        <span v-else> {{ getRegleAchat(props.row.produitAchatCommissionId) }} </span>
      </div>
      <div slot="dateDebut" slot-scope="props">
        <b-datepicker show-week-number v-if="!detail"
                      nearby-selectable-month-days
                      :value="props.row.dateDebut"
                      icon="calendar-today"
                      @input="updateValue(props.index, 'dateDebut', $event)"
                      :editable="true">
        </b-datepicker>
        <span v-else> {{ props.row.dateDebut | formatDate }} </span>
      </div>
      <div slot="dateFin" slot-scope="props">
        <b-datepicker show-week-number v-if="!detail"
                      nearby-selectable-month-days
                      :value="props.row.dateFin"
                      icon="calendar-today"
                      @input="updateValue(props.index, 'dateFin', $event)"
                      :editable="true">
        </b-datepicker>
        <span v-else> {{ props.row.dateFin | formatDate }} </span>
      </div>
      <div slot="typeCalcul" slot-scope="props">
        <b-select v-model="props.row.typeCalcul" expanded v-if="!detail"
                  @input="updateValue(props.index, 'typeCalcul', $event)">
          <option v-for="typeCalcul in listeTypeCalcul"
                  :key="typeCalcul.key"
                  :value="typeCalcul.key">
            {{ $t(typeCalcul.libelle) }}
          </option>
        </b-select>
        <span v-else> {{ $t(getTypeCalculLibelle(props.row.typeCalcul)) }} </span>
      </div>
      <div slot="typeMontant" slot-scope="props">
        <b-select v-model="props.row.typeMontant" expanded v-if="!detail"
                  @input="updateValue(props.index, 'typeMontant', $event)">
          <option v-for="typeMontant in listeTypeMontant"
                  :key="typeMontant.key"
                  :value="typeMontant.key">
            {{ $t(typeMontant.libelle) }}
          </option>
        </b-select>
        <span v-else> {{ $t(getTypeMontantLibelle(props.row.typeMontant)) }} </span>
      </div>
      <div slot="regimeTvaId" slot-scope="props">
        <b-select v-model="props.row.regimeTvaId" expanded v-if="!detail"
                  @input="updateValue(props.index, 'regimeTvaId', $event)">
          <option v-for="tva in regimeTva"
                  :key="tva.id"
                  :value="tva.id">
            {{ tva.tauxTva | formatPercent }}
          </option>
        </b-select>
        <span v-else> {{ props.row.regimeTva.tauxTva | formatPercent }} </span>
      </div>
      <div slot="pourcentageReversement" slot-scope="props">
        <b-input v-model="props.row.pourcentageReversement" type="number" expanded  v-if="!detail"
                 step="0.01"
                 @input="updateValue(props.index, 'pourcentageReversement', $event)"></b-input>
        <span v-else-if="props.row.pourcentageReversement !== null">
          {{ props.row.pourcentageReversement | formatPercent }}
        </span>
      </div>
      <div slot="montantFixeReversement" slot-scope="props">
        <b-input v-model="props.row.montantFixeReversement" type="number" expanded  v-if="!detail"
                 step="0.01"
                 @input="updateValue(props.index, 'montantFixeReversement', $event)"></b-input>
        <span v-else>{{ props.row.montantFixeReversement | formatDevise }}</span>
      </div>
      <div slot="montantReversementGaranti" slot-scope="props">
        <b-input v-model="props.row.montantReversementGaranti" type="number" expanded
                 v-if="!detail" step="0.01"
                 @input="updateValue(props.index, 'montantReversementGaranti', $event)"></b-input>
        <span v-else>{{ props.row.montantReversementGaranti | formatDevise }}</span>
      </div>
      <div slot="cAGaranti" slot-scope="props">
        <b-input v-model="props.row.caGaranti" type="number" expanded
                 v-if="!detail" step="0.01"
                 @input="updateValue(props.index, 'caGaranti', $event)"></b-input>
        <span v-else>{{ props.row.caGaranti | formatDevise }}</span>
      </div>
      <div slot="newTranche" slot-scope="props">
        <b-tooltip type="is-primary" v-if="props.row.typeMontant === tranche"
                   position="is-left"
                   :label="$t('produitSalon.reglesAchat.addTranche')">
          <a @click="addTranches(props.index)">
            <b-icon class="mgt-5px" icon="plus-box" type="is-success"></b-icon>
          </a>
        </b-tooltip>
      </div>
      <div slot="delete" slot-scope="props">
        <a @click="deleteObjectif(props.index)">
          <b-icon class="mgt-5px" icon="delete-forever" type="is-danger"></b-icon>
        </a>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import selecteurAction from '@/components/general/selecteurAction';
import MsgInfoProduit from '@/components/presse/regroupementProduit/informations/MsgInfoProduit';
import genererReglesAchat from '@/services/presse/salon/genererReglesAchat';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
  NO_PAGINATION,
} from '@/configuration/clientTableConf';
import {
  ACTION_DUPLICATION,
  ACTION_SUPPRESSION,
  LISTE_TYPE_CALCUL_REGLE_ACHAT,
  LISTE_TYPE_MONTANT_REGLE_ACHAT, TRANCHE,
} from '@/configuration/presse/produitSalon/produitSalonConfiguration';
import { EXPORT_EXCEL_REGLES_ACHAT } from '@/configuration/presse/produitPresse/produitPresseConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import genererTranches from '@/services/presse/salon/genererTranches';
import { columnsSplice } from '@/services/general/columns';
import tranche from '@/components/catalogue/produitGeneralPresse/edition/tranche';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { getAll as getAllDivers } from '@/api/produit/produitDivers';
import { SENS_ACHAT } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    produit: {
      required: true,
      type: Object,
    },
    detail: {
      required: false,
      type: Boolean,
      default: false,
    },
    showMsgRegroupementProduit: {
      type: Boolean,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      actions: [
        { action: ACTION_DUPLICATION, translation: 'produitSalon.reglesAchat.actions.dupliquer' },
        { action: ACTION_SUPPRESSION, translation: 'produitSalon.reglesAchat.actions.supprimer' },
      ],
      listeTypeCalcul: LISTE_TYPE_CALCUL_REGLE_ACHAT,
      listeTypeMontant: LISTE_TYPE_MONTANT_REGLE_ACHAT,
      tranche: TRANCHE,
      allProduitAchat: [],
    };
  },
  components: {
    selecteurAction,
    MsgInfoProduit,
    tranche,
    exportExcelButton,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    regimeTva() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif;
      });
    },
    allRegleAchatSelected() {
      return this.getAllReglesAchatSelected().length === this.produit.reglesAchat.length;
    },
    columns() {
      const columns = ['selected', 'produitAchatCommissionId', 'dateDebut', 'dateFin', 'typeCalcul', 'typeMontant', 'regimeTvaId', 'pourcentageReversement', 'montantFixeReversement', 'montantReversementGaranti', 'cAGaranti', 'newTranche', 'delete'];
      if (this.detail) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'delete');
        columnsSplice(columns, 'newTranche');
      }
      if (!this.hasChildRow) {
        columnsSplice(columns, 'newTranche');
      }
      return columns;
    },
    hasChildRow() {
      return this.produit.reglesAchat.some((el) => el.typeMontant === TRANCHE);
    },
    iconSelectTotal() {
      if (this.allRegleAchatSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateDebut: this.$t('produitSalon.reglesAchat.dateDebut'),
          dateFin: this.$t('produitSalon.reglesAchat.dateFin'),
          typeCalcul: this.$t('produitSalon.reglesAchat.typeCalcul'),
          typeMontant: this.$t('produitSalon.reglesAchat.typeMontant'),
          regimeTvaId: this.$t('produitSalon.reglesAchat.regimeTva'),
          pourcentageReversement: this.$t('produitSalon.reglesAchat.pourcentageReversement'),
          montantFixeReversement: this.$t('produitSalon.reglesAchat.montantFixeReversement'),
          montantReversementGaranti: this.$t('produitSalon.reglesAchat.montantReversementGaranti'),
          cAGaranti: this.$t('produitSalon.reglesAchat.cAGaranti'),
          produitAchatCommissionId: this.$t('produitSalon.reglesAchat.produitAchat'),
          newTranche: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allRegleAchatSelected;
                    this.produit.reglesAchat.forEach(item => {
                      item.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        rowClassCallback: ((row) => {
          if (row.typeMontant !== TRANCHE) {
            return 'hideChildToggler';
          }
          return 'activeChildRowClick';
        }),
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          dateDebut: 'colonneMinWidth-150px',
          dateFin: 'colonneMinWidth-150px',
          typeCalcul: 'colonneMinWidth-150px',
          typeMontant: 'colonneMinWidth-150px',
          regimeTvaId: 'colonneMinWidth-150px',
        },
        sortable: this.detail ? ['annee', 'commercial', 'montantHt', 'produitAchatCommissionId'] : [],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_REGLES_ACHAT,
        typeExport: null,
        filtres: {
          query: { produitId: this.produit.id },
        },
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getAllReglesAchatSelected() {
      return this.produit.reglesAchat.filter((el) => {
        return el.selected;
      });
    },
    getTypeCalculLibelle(code) {
      return this.listeTypeCalcul.find((el) => el.key === code).libelle;
    },
    getTypeMontantLibelle(code) {
      return this.listeTypeMontant.find((el) => el.key === code).libelle;
    },
    getRegleAchat(id) {
      if (id === null) return this.$t('societes.produitDefaut');
      return this.allProduitAchat.find(p => p.id === id)?.libelle ?? '';
    },
    handleAction(action) {
      switch (action) {
        case ACTION_DUPLICATION:
          this.duplicationRegle();
          break;
        case ACTION_SUPPRESSION:
          this.produit.reglesAchat = this.produit.reglesAchat.filter((el) => !el.selected);
          break;
        default:
          break;
      }
    },
    addRegleAchat() {
      const newRegleAchat = genererReglesAchat();
      newRegleAchat.produitId = this.produit.id;
      this.produit.reglesAchat.push(newRegleAchat);
    },
    updateValue(index, variable, value) {
      if (variable === 'typeMontant' && value !== TRANCHE) {
        this.produit.reglesAchat[index - 1].tranchesAchat = [];
      }
      this.produit.reglesAchat[index - 1][variable] = value;
    },
    updateValueTranche(indexRegle, index, variable, value) {
      this.produit.reglesAchat[indexRegle - 1].tranchesAchat[index][variable] = value;
    },
    duplicationRegle() {
      const newRegle = cloneDeep(this.produit.reglesAchat.filter((el) => {
        return el.selected;
      }));
      newRegle.forEach((el) => {
        el.selected = false;
        if (el.id) delete el.id;
        el.tranchesAchat
          .forEach(t => delete t.id);
      });
      this.produit.reglesAchat = this.produit.reglesAchat.concat(newRegle);
    },
    deleteObjectif(index) {
      this.produit.reglesAchat.splice(index - 1, 1);
    },
    deleteTranche(indexRegle, index) {
      this.produit.reglesAchat[indexRegle - 1].tranchesAchat.splice(index, 1);
    },
    addTranches(index) {
      this.produit.reglesAchat[index - 1].tranchesAchat.push(genererTranches());
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.regimeTva]);
      const queryItemDivers = {
        query: {
          societeId: this.produit.societeId ?? this.societeActiveId,
          sens: SENS_ACHAT,
          actif: true,
        },
        orderBy: 'ProduitDivers.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      this.allProduitAchat = (await getAllDivers(queryItemDivers)).data.result.items;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
